import Facebook from './Facebook'
import axios from 'axios'

export default class Adcreatives extends Facebook {
  constructor (user, parameters = null) {
    super(user)
    this.user = user
    this.parameters = parameters
  }
  createAdCreative () {
    const account = this.connection().account
    let linkData
    let objectStorySpec
    if (this.parameters.video) {
      linkData = {
        call_to_action: {type: this.parameters.callToAction, value: {link: this.parameters.link}},
        message: this.parameters.message,
        video_id: this.parameters.video.id,
        image_url: this.parameters.video.picture
      }
      objectStorySpec = {
        video_data: linkData,
        page_id: this.user.selectedAccount
      }
    } else {
      linkData = {
        call_to_action: {type: this.parameters.callToAction, value: {link: this.parameters.link}},
        description: this.parameters.description,
        link: this.parameters.link,
        message: this.parameters.message,
        name: this.parameters.name,
        caption: this.parameters.caption,
        picture: this.parameters.image_url
      }
      objectStorySpec = {
        link_data: linkData,
        page_id: this.user.selectedAccount
      }
    }
    const params = {
      access_token: this.user.token,
      name: this.parameters.name,
      authorization_category: this.parameters.political,
      object_story_spec: objectStorySpec,
      url_tags: this.parameters.url_tags
    }
    return account.createAdCreative([], params)
      .catch(err => {
        throw new Error(JSON.stringify(err))
      })
  }
  searchByQuery () {
    return axios({
      method: 'GET',
      url: 'search',
      params: {
        access_token: this.user.token,
        location_types: this.parameters.types,
        type: 'adgeolocation',
        q: this.parameters.query
      }
    })
      .catch(err => {
        throw new Error(JSON.stringify(err))
      })
  }
  getAdCreativeById () {
    return axios({
      method: 'GET',
      url: `${this.parameters.adcreative_id}`,
      params: {
        access_token: this.user.token,
        fields: 'name, image_url, call_to_action_type, object_story_spec, title, video_id'
      }
    })
      .then(res => {
        return res.data
      })
  }
}
